import parser from './parser';

const name = 'slider';


export default {parser, name};
